// frontend/src/marketing/PublicLayout.jsx
import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import PublicHeader from "./PublicHeader";
import PublicFooter from "./PublicFooter";
import SiteBanner from "./SiteBanner";
import { trackPageview } from "./analytics";

/**
 * PublicLayout — marketing shell (header + footer) for all public routes.
 * Distinct from the authenticated app `Layout`. Scrolls to top on route change
 * so deep-linked marketing pages don't inherit the previous scroll position.
 */
export default function PublicLayout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageview(pathname); // consent-gated; no-op without consent + endpoint
  }, [pathname]);

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-brand-600 focus:px-4 focus:py-2 focus:text-white"
      >
        Skip to content
      </a>
      <SiteBanner />
      <PublicHeader />
      <main id="main" className="flex-1">
        <Outlet />
      </main>
      <PublicFooter />
    </div>
  );
}
